import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { RouteComponentProps, withRouter } from "react-router";
import styled from "styled-components";
import backgroundImage from '../../assets/service_type/terapia.jpg';
import { RightCircleOutlined } from '@ant-design/icons';

const SectionContainer = styled.div`
  padding: 4rem 0;
  position: relative;
  background: url(${backgroundImage}) no-repeat center center;
  background-size: cover;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    z-index: 1;
  }
`;

const ContentWrapper = styled.div`
    position: relative;
    z-index: 2;
`;

const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  font-weight: bold;
`;

const InfoCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  height: 100%;
`;

const InfoTitle = styled.h3`
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

const InfoList = styled.ul`
  list-style: none;
  padding-left: 0;
`;

const InfoListItem = styled.li`
  margin-bottom: 1rem;
  font-size: 1.1rem;
  line-height: 1.6;
  display: flex;
  align-items: center;

  .anticon {
    color: #007bff;
    margin-right: 10px;
    font-size: 1.2rem;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 2rem;
`;

function VisitInfoView(props: RouteComponentProps) {
  return (
    <SectionContainer>
        <ContentWrapper className="container">
            <SectionTitle>Wizyta</SectionTitle>
            <Row>
                <Col md={6} className="mb-4">
                    <InfoCard>
                        <InfoTitle>Kto powinien się umówić?</InfoTitle>
                        <InfoList>
                            <InfoListItem><RightCircleOutlined />osoby które zauważyły wzmożone wypadnie włosów</InfoListItem>
                            <InfoListItem><RightCircleOutlined />osoby, które zauważyły nadmierne przerzedzenie włosów</InfoListItem>
                            <InfoListItem><RightCircleOutlined />osoby u których kondycja łodygi włosa uległa pogorszeniu (suche, łamliwe włosy)</InfoListItem>
                            <InfoListItem><RightCircleOutlined />osoby borykające się ze schorzeniami owłosionej skory głowy</InfoListItem>
                        </InfoList>
                    </InfoCard>
                </Col>
                <Col md={6} className="mb-4">
                    <InfoCard>
                        <InfoTitle>Jak wygląda wizyta?</InfoTitle>
                        <InfoList>
                            <InfoListItem><RightCircleOutlined />Szczegółowy wywiad trychologiczny.</InfoListItem>
                            <InfoListItem><RightCircleOutlined />Trichoskopowe badanie skóry głowy.</InfoListItem>
                            <InfoListItem><RightCircleOutlined />Dobór odpowiedniej kuracji i pielęgnacji.</InfoListItem>
                        </InfoList>
                    </InfoCard>
                </Col>
            </Row>
            <ButtonContainer>
                <Button variant="primary" size="lg" onClick={() => props.history.push('/wizyta')}>
                Umów się już dziś!
                </Button>
            </ButtonContainer>
        </ContentWrapper>
    </SectionContainer>
  );
}

export default withRouter(VisitInfoView);
